import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadingState } from './core/loading.state';
import { AppCheckHealth } from './core/app-features/app-features.action';
import { BillyticsAnalyticEvents, GoogleAnalyticsService } from './core/google-analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  title = 'billytics-web';
  #store = inject(Store);
  loadingAllSpinner$ = this.#store.selectSignal(LoadingState.loadingAllSpinner);
  #googleAnalyticsService = inject(GoogleAnalyticsService);

  ngAfterViewInit(): void {
    this.#store.dispatch(new AppCheckHealth());
    this.#googleAnalyticsService.logCustomEvents(BillyticsAnalyticEvents.APP_OPEN);
  }
}
